<div class="pt-4 pb-4 pl-md-5 pr-md-5 masthead bg-white">
    <div class="row justify-content-between align-items-center m-0">
        <p class="mb-0 h3">
            <i class="fa mr-3 fa-cogs"></i>
            Workflow
        </p>
        <div class="col col-md-4 pr-md-0 text-right">
            <input type="text" [(ngModel)]="searchTerm" class="form-control" placeholder="Search countries..." />
        </div>
    </div>
</div>

<div class="container">
    <div class="row mt-5">
        <div class="col">

            <h3>Default configuration</h3>
            <p class="text-muted">Once configured, the default configuration can be applied to each location in turn.
            </p>
            <ul class="list-group mb-5 mt-3">
                <li class="list-group-item list-group-item-action justify-content-between align-items-center"
                    (click)="workflowClicked(defaultConfig)">
                    <div>
                        <p class="mb-0">
                            <strong>{{defaultConfig?.name}}</strong>
                        </p>
                    </div>
                    <div *ngIf="defaultConfig?.workflowId" class="badge badge-info">
                        Workflow configured
                        <i class="fa fa-check ml-2"></i>
                    </div>
                </li>
            </ul>

            <h3>Countries</h3>
            <p class="text-muted">
                To manage content for a particular location, you must first configure it's workflow.
            </p>
            <ul class="list-group mt-3">
                <li class="list-group-item list-group-item-action justify-content-between align-items-center"
                    *ngFor="let item of countryConfig | arraypropertyfilter: 'name' : searchTerm"
                    (click)="workflowClicked(item)">
                    <div>
                        <p class="mb-0">
                            <strong>{{item.name}}</strong>
                        </p>
                    </div>
                    <div *ngIf="item?.workflowId" class="badge badge-info">
                        Workflow configured
                        <i class="fa fa-check ml-2"></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>